import React from "react";
import { Slide } from "react-reveal";
import Mission from "../reusables/Mission";

const AboutBody = () => {
  return (
    <section className="section section-spacing-50 no-padding-bottom cloudy-bg">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="textpage-container">
              <div className="textpage-inner section-spacing-50 no-padding-top flex">
                <div className="textpage-text-side">
                  <h2 className="green">NEGASH CONSTRUCTION COMPANY LTD</h2>
                  <div className="textpage-text-body">
                    <p>
                      The story of Negash Construction Company starts with Mr.
                      Negash Tesfatsion who is is a founding and CEO of NEGASH
                      Construction Company Co. Ltd. He has a wide range of
                      experience in a variety of roles including Project
                      Management, Development Management and Subcontracting and
                      has been immersed in the Construction industry since 1994.
                    </p>
                    <p>
                      Negash started his career in the field of construction as
                      Forman with SEGEN Construction Company (Eritrea) in 1994
                      and promoted to Project Site Manager in 2001 and Operation
                      Manager in 2008.
                    </p>
                    <p>
                      Negash partnered with LOROSOK Investment Co. Ltd in 2010
                      to start general construction activities in South Sudan.
                      He started his duties as Operation Manager, where he led
                      the construction of seven (7) different projects from 2011
                      up to the middle of 2014.
                    </p>
                    <p>
                      In 2014, Mr. Negash separated from LOROSOK Investment Ltd
                      to start Negash Construction Company and completed
                      successful initial construction G+2 at Konokonyo Market,
                      Juba, South Sudan and a residential complex in Munuki
                      Area.
                    </p>
                    <p>
                      Today, NEGASH Construction Company is one of the leading
                      constructing Companies in South Sudan undertaking
                      construction of civil and structural works including with
                      interior and exterior, electrical and plumbing works for
                      commercial and residential buildings at various locations
                      of South Sudan. Besides, in liaison with our
                      subcontractors we undertake the mechanical (HVAC) section
                      of the same project as per our client’s interest.
                    </p>
                    <p>
                      Our growing reputation for excellence, resourcefulness and
                      responsiveness is no accident. It is a natural consequence
                      of the values that have guided our company since its
                      founding. These include an energetic enthusiasm for what
                      we do. Sensitivity to the needs of our customers, a
                      willingness to accept total responsibility and a crafts
                      manlike pride in knowing that what we build will last for
                      generations. While some in our industry might find these
                      attitudes old-fashioned, we believe they are why
                      knowledgeable businesses, organizations and architects
                      throughout the country place their confidence, and their
                      trust, in Negash Construction Company. Simply put, we
                      think it's a better way to build.
                    </p>
                    <h3>Our Vision</h3>
                    <p>
                      NEGASH CONSTRUCTION COMPANY is committed to building
                      long-term relationships based on integrity, performance,
                      value, and client satisfaction, with a balance of work
                      across the public and private sectors and a reputation for
                      local knowledge and delivery.
                    </p>
                    <p>
                      We will continue to meet the changing needs of our clients
                      with our quality services delivered by the most qualified
                      people. No matter how challenging a project or how remote
                      its location, we can enter into new contract agreement and
                      can handle it properly. To that end, our motto or slogan
                      is “WE DELIVER”.
                    </p>
                    <h3>Our Mission</h3>
                    <div>
                      <p>
                        Through collaboratively working and knowledge sharing we
                        deliver outstanding results for all our stakeholders. We
                        do this by working with integrity and acting in a fair
                        and socially responsible manner, with particular
                        emphasis on the well-being of our colleagues and the
                        communities where we work and live.
                      </p>
                      <p>
                        The following outlines how Negash Construction C0.Ltd
                        seeks to conduct itself internally as an organization,
                        externally as company, and as an ongoing active member
                        of the local community.
                      </p>
                      <p className="bold">CLIENTS:</p>
                      <p>
                        We strive to meet and exceed our client’s expectations
                        to foster long term partnerships.
                      </p>
                      <p className="bold">EMPLOYEES:</p>
                      <p>
                        We value our staff and create an enjoyable work
                        environment which allows personal fulfillment that leads
                        to a loyal and productive work force.
                      </p>
                      <p className="bold">TRADES:</p>
                      <p>
                        We treat our sub-trades and suppliers with respect to
                        cultivate a team approach where experience is applied
                        with dedicated enthusiasm.
                      </p>
                      <p className="bold">THE COMPANY:</p>
                      <p>
                        We use value engineering, effective construction
                        practices and hard work to deliver the construction.
                      </p>
                    </div>
                    <h3>Our Core Values</h3>
                    <ul>
                      <li>
                        <strong>Proactive:</strong> We overcome challenges and
                        find sustainable solutions through PROACTIVE solutions.
                      </li>
                      <li>
                        <strong> Professionalism:</strong> We behave in a
                        PROFESSIONAL manner at all times.
                      </li>
                      <li>
                        <strong> Safety: </strong> No task is so important that
                        we cannot find a safe way to do it.
                      </li>
                      <li>
                        <strong> Integrity: </strong> We do the right thing for
                        our customers and employees. We do what we say.
                      </li>
                      <li>
                        <strong> Pride: </strong> We take PRIDE in all we do and
                        who we are.
                      </li>
                      <li>
                        <strong> Profitability: </strong> We provide great value
                        for a fair return. We strategically re-invest our
                        profits to maintain operational excellence.
                      </li>
                      <li>
                        <strong> Customer Satisfaction: </strong> We listen, we
                        build trusting relationships and we stand behind our
                        work.
                      </li>
                      <li>
                        <strong> Partnering: </strong> We achieve success
                        through a PARTNERING and collaborative approach.
                      </li>
                      <li>
                        <strong> Economic Inclusion and Diversity: </strong> We
                        are dedicated to being top-of-class in providing
                        mentoring and opportunities for emerging firms.
                      </li>
                      <li>
                        <strong> Innovation: </strong> We collaborate to
                        innovate and deliver the highest expertise.
                      </li>
                      <li>
                        <strong> Social Responsibility: </strong> We are
                        committed to the community and environment.
                      </li>
                    </ul>

                    <div className="team-section">
                      <div className="team">
                        <div className="team-section-head center">
                          <h2>OUR Key Personnels</h2>
                          <p>
                            Our Company hires only the highest skilled tradesmen
                            to perform our work. We believe in our staff's
                            ability to provide our clients with the best in
                            construction value and service.
                          </p>
                        </div>
                        <div className="team-section-body">
                          <table>
                            <tr>
                              <th>Name</th>
                              <th>Position</th>
                              <th>Profession</th>
                              <th>Experience</th>
                            </tr>
                            <tr>
                              <td>Negash Tesfatsion</td>
                              <td>Managing Director</td>
                              <td>HS</td>
                              <td>25 Years</td>
                            </tr>
                            <tr>
                              <td>Abraham Mengstu</td>
                              <td>Technical Administrator</td>
                              <td>Bsc in Civil Engineering</td>
                              <td>13 Years</td>
                            </tr>
                            <tr>
                              <td>Frank</td>
                              <td>Site Engineer</td>
                              <td>Bsc. in Civil Engineering</td>
                              <td>4 Years</td>
                            </tr>
                            <tr>
                              <td>Simon Mussie</td>
                              <td>Project Engineer</td>
                              <td>Bsc. in Civil Engineering</td>
                              <td>8 Years</td>
                            </tr>
                            <tr>
                              <td>Abraham Mengstu</td>
                              <td>Office Engineer</td>
                              <td>Bsc. in Civil Engineering</td>
                              <td>13 Years</td>
                            </tr>
                            <tr>
                              <td>Teklzghi Tesfay</td>
                              <td>Finance Manager</td>
                              <td>BA. In Social Science</td>
                              <td>9 Years</td>
                            </tr>
                            <tr>
                              <td>Mulubrhan Estifanos</td>
                              <td>Accountant</td>
                              <td>BA. In Accounting</td>
                              <td>4 Years</td>
                            </tr>
                            <tr>
                              <td>Efrem</td>
                              <td>Forman</td>
                              <td>12th Grade</td>
                              <td>13 Years</td>
                            </tr>
                            <tr>
                              <td>Michael Gebretnsae</td>
                              <td>Surveyor</td>
                              <td>Surveying and Drafting</td>
                              <td>6 Years</td>
                            </tr>
                            <tr>
                              <td>Emanuel Taeban</td>
                              <td>Forman</td>
                              <td>11th Grade</td>
                              <td>6 Years</td>
                            </tr>
                            <tr>
                              <td>Denden Yemane</td>
                              <td>Project Engineer</td>
                              <td>Bsc. in Civil Engineering</td>
                              <td>10 Years</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                    <h3>Our Location &amp; Contacts</h3>
                    <p>
                      We are located in Hai-Malakal, Juba, South Sudan. You can
                      always give us a call or WhastApp on +211 (921) 782 856 or
                      send us an email info@negash.co.
                    </p>
                  </div>
                </div>
                <Mission />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBody;
